import { useEffect, useState, useRef } from "react";
import { getVideoListMenu, getVideoCategory } from "@/api/videoPlay";
import { Carousel, Modal, Pagination } from "antd";
import { useNavigate } from "react-router-dom";
import VideoDetail from "./components/videoDetail";
import "./index.less";

const VideoPlayer = () => {
  const [categoryTwo, setCategoryTwo] = useState([]);
  const [showVideoPlayer, setShowVideoPlayer] = useState<boolean>(false);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 8;
  const videoUrl = useRef<string>("");
  const navigate = useNavigate();
  const paginationChange = (e: number) => {
    getVideoData(e);
    setCurrent(e);
  };
  //获取视频分类
  const getVideoData = (pageNumber: any) => {
    getVideoCategory({
      pageNumber,
      pageSize: pageSize,
      order: "",
      sort: "",
      keyword: "",
      notConvert: true,
    }).then((res: any) => {
      if (res.code == 200) {
        console.log(res.result);
        setTotal(res.result.total);
        setCategoryTwo(res.result.records);
      }
    });
  };

  // 跳转详情页
  const jumpUrl = (id: any) => {
    // 判断当前视频 child 否仅有一条
    getVideoListMenu({
      id,
    }).then((res: any) => {
      if (res.code == 200) {
        console.log(res.result);
        if (res.result.children.length === 1) {
          videoUrl.current = res.result?.children?.[0]?.videoUrl;
          setShowVideoPlayer(true);
        } else {
          navigate(`/videoPlayer/videoCollection?id=${id}`);
        }
      }
    });
  };

  const closeVideo = () => {
    setShowVideoPlayer(false);
  };

  useEffect(() => {
    getVideoData(1);
  }, []);

  return (
    <div className="video-play-wrap">
      <div className="video-play-banner">
        <Carousel className="video-play-banner-box">
          <div className="video-play-img">
            <img src="https://kh-mall.obs.cn-north-1.myhuaweicloud.com/STORE/1376417684140326912/20241029/40ba4f952e75400dbe42b399c1482ccf.png" />
          </div>
        </Carousel>
        <div className="video-play-banner-content">
          <div className="video-play-name">学习课程</div>
          <div className="video-play-description">KaihongOS南北向技术开发课程陆续迭代上线中</div>
        </div>
      </div>
      <div className="video-play-content">
        {categoryTwo.map((item: any) => {
          return (
            <div
              className="video-play-content-item"
              key={item.id}
              onClick={() => {
                jumpUrl(item.id);
              }}
            >
              <div className="content-item-img">
                <img src={item?.image} />
              </div>
              <div className="content-item-name">{item.name}</div>
              <div className="content-item-description">{item?.categoryDescribe || ""}</div>
            </div>
          );
        })}
      </div>
      {pageSize < total && (
        <div className="flex-center">
          <Pagination pageSize={pageSize} current={current} total={total} rootClassName="pagination" onChange={paginationChange} />
        </div>
      )}

      {showVideoPlayer && (
        <Modal
          open={showVideoPlayer}
          maskClosable={false}
          closable={false}
          onCancel={() => {
            setShowVideoPlayer(false);
          }}
          onOk={closeVideo}
          wrapClassName="video-player-model"
        >
          <VideoDetail close={closeVideo} url={videoUrl.current} />
        </Modal>
      )}
    </div>
  );
};

export default VideoPlayer;
